/**
 * Format currency amount with spaces as thousands separators
 * @param amount - The numeric amount to format
 * @param currency - The currency symbol (default: 'R')
 * @returns Formatted currency string with spaces as thousands separators
 */
export const formatCurrency = (amount: number, currency: string = 'R'): string => {
  if (isNaN(amount)) return `${currency}0.00`;

  // Use South African locale first, then replace commas with spaces
  const formatted = amount.toLocaleString('en-ZA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  // Replace commas with spaces for thousands separators, but keep decimal point
  // Split on decimal point first
  const parts = formatted.split('.');
  const integerPart = parts[0].replace(/,/g, ' ');
  const decimalPart = parts[1] || '00';

  return `${currency}${integerPart}.${decimalPart}`;
};

/**
 * Format a number with spaces as thousands separators (no currency symbol)
 * @param amount - The numeric amount to format
 * @returns Formatted number string with spaces as thousands separators
 */
export const formatNumber = (amount: number): string => {
  if (isNaN(amount)) return '0';

  const formatted = amount.toLocaleString('en-ZA');
  // Split on decimal point first if present
  const parts = formatted.split('.');
  const integerPart = parts[0].replace(/,/g, ' ');
  return parts[1] ? `${integerPart}.${parts[1]}` : integerPart;
};
